<script setup lang="ts">
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<{
    class?: HTMLAttributes['class'];
  }>();
</script>

<template>
  <td :class="cn('align-middle', props.class)">
    <slot />
  </td>
</template>
